let fetcherMixin = {
  data() {
    return {
      isLoading: false
    }
  },
  methods: {
    keysToCamel(o) {
      let self = this
      const toCamel = s => {
        return s.replace(/([-_][a-z])/gi, $1 => {
          return $1
            .toUpperCase()
            .replace('-', '')
            .replace('_', '')
        })
      }
      const isArray = function(a) {
        return Array.isArray(a)
      }
      const isObject = function(o) {
        return o === Object(o) && !isArray(o) && typeof o !== 'function'
      }
      if (isObject(o)) {
        const n = {}

        Object.keys(o).forEach(k => {
          n[toCamel(k)] = self.keysToCamel(o[k])
        })

        return n
      } else if (isArray(o)) {
        return o.map(i => {
          return self.keysToCamel(i)
        })
      }

      return o
    },
    async request(requestObj) {
      let self = this
      self.isLoading = true
      self.$Progress.start()
      requestObj()
        .catch(function(e) {
          console.log(e)
          self.$toast.open({
            message: 'Ha ocurrido un error',
            type: 'error'
          })
        })
        .then(function() {
          self.isLoading = false
          self.$Progress.finish()
        })
    }
  }
}

export default fetcherMixin
